import React from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { formatShortcut, toggleBlockQuote } from '@atlaskit/editor-common/keymaps';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarDropdownItem, ToolbarKeyboardShortcutHint } from '@atlaskit/editor-toolbar';
export var QuoteButton = function QuoteButton(_ref) {
  var blockType = _ref.blockType,
    api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var availableBlockTypesInDropdown = useSharedPluginStateSelector(api, 'blockType.availableBlockTypesInDropdown');
  var currentBlockType = useSharedPluginStateSelector(api, 'blockType.currentBlockType');
  if (!(availableBlockTypesInDropdown !== null && availableBlockTypesInDropdown !== void 0 && availableBlockTypesInDropdown.some(function (availableBlockType) {
    return availableBlockType.name === blockType.name;
  }))) {
    return null;
  }
  var onClick = function onClick() {
    var _api$core, _api$blockType;
    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 || (_api$blockType = _api$blockType.commands) === null || _api$blockType === void 0 ? void 0 : _api$blockType.insertBlockQuote(INPUT_METHOD.TOOLBAR));
  };
  var shortcut = formatShortcut(toggleBlockQuote);
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    elemBefore: blockType.icon,
    elemAfter: shortcut ? /*#__PURE__*/React.createElement(ToolbarKeyboardShortcutHint, {
      shortcut: shortcut
    }) : undefined,
    onClick: onClick,
    isSelected: currentBlockType === blockType,
    ariaKeyshortcuts: shortcut
  }, formatMessage(blockType.title));
};